import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type AdminRole = 'system_admin' | 'company_admin' | 'customer_success' | 'finance' | 'agency_manager';
export type AdminCompanyScope = 'all' | 'company' | 'assigned';

export interface AdminUser {
  email: string;
  name: string;
  role: AdminRole;
  companyScope: AdminCompanyScope;
}

interface AdminAuthState {
  admin: AdminUser | null;
  token: string | null;
  isAuthenticated: boolean;
  login: (admin: AdminUser, token: string) => void;
  logout: () => void;
}

export const useAdminAuthStore = create<AdminAuthState>()(
  persist(
    (set) => ({
      admin: null,
      token: null,
      isAuthenticated: false,

      login: (admin, token) => {
        set({
          admin,
          token,
          isAuthenticated: true,
        });
      },

      logout: () => {
        set({
          admin: null,
          token: null,
          isAuthenticated: false,
        });
      },
    }),
    {
      name: 'admin-auth-storage',
      partialize: (state) => ({
        admin: state.admin,
        token: state.token,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);